module.exports = __webpack_public_path__ + "img/place.2dace6b6.svg";